import React from "react";
import { useLocation } from "react-router-dom";
import "../Styles/NotFound.css"

function NotFound() {
  const deployedURL = window.location.href;
  const location = useLocation();

  return (
      <div className="not-found-container ">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page Not Found</h2>
          <p className="not-found-description">The Page you are looking for doesn't exist or another error occurred. Go to <a href="/">Home Page.</a></p>
      </div>
  );
}

export default NotFound;
